export const enhancePlayerConfig = async config => config;
